var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{ref:"displayImage",attrs:{"id":"display-image","size":"lg","no-close-on-backdrop":"","no-close-on-esc":"","hide-footer":""},on:{"hidden":function($event){return _vm.closeModal()}}},[_c('b-img',{attrs:{"src":_vm.url,"fluid-grow":"","alt":"Responsive image"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }